import "core-js/modules/esnext.array.last-item.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.HeaderProfileDropdown
  }, [_c('ul', [_c('li', {
    class: _vm.$style.listItem
  }, [_c('NuxtLink', {
    class: [_vm.$style.listItemContent, _vm.$style.listItemContentClickable],
    attrs: {
      "to": _setup.ROUTE_PATHS.profile
    },
    nativeOn: {
      "click": function click($event) {
        return _setup.emit('dropdown-item-click');
      }
    }
  }, [_c(_setup.SIcon, {
    attrs: {
      "icon": "i-user",
      "size": "24"
    }
  }), _vm._v("\n        Профили\n      ")], 1)], 1), _vm._v(" "), _vm._t("menu-extra", null, {
    "onItemClick": function onItemClick() {
      return _setup.emit('dropdown-item-click');
    }
  })], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    class: [_vm.$style.listItemContent, _vm.$style.listItemContentClickable, _vm.$style.lastItem],
    on: {
      "click": _setup.onLogoutClick
    }
  }, [_c(_setup.SIcon, {
    attrs: {
      "icon": "i-logout",
      "size": "24"
    }
  }), _vm._v("\n    Выйти\n  ")], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };